import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';


export class Layout extends Component<{ hideNavbar: boolean; isAuthenticated: boolean; }> {
    static displayName = Layout.name;

    render() {
        return (
            <div>
                {!this.props.hideNavbar && <NavMenu isAuthenticated={this.props.isAuthenticated} />}
                <Container>
                    <div className="mt-3">
                        {this.props.children}
                    </div>
                </Container>
            </div>
        );
    }
}
